import { type ReactNode } from 'react';
import { useChannelMembers } from '../hooks/useChannelMembers';
import { channelDraftKey } from '../hooks/useComposerDraft';
import { useNormalizedSessionScope, useProviderOutputMode } from '../hooks/useNormalizedSessionScope';
import NormalizedConversation from './NormalizedConversation';

/** A single authenticated agent selects the conversation protocol for this channel. */
export default function ChannelConversation({ channelId, isDirectMessage = false, canWrite, messages, composer }: {
  channelId: string;
  isDirectMessage?: boolean;
  canWrite: boolean;
  messages: ReactNode;
  composer: ReactNode;
}) {
  const { members, status } = useChannelMembers(channelId);
  const agents = members.filter(member => member.role === 'agent');
  const agent = status === 'ready' && agents.length === 1 ? agents[0] : undefined;
  const outputMode = useProviderOutputMode(agent);
  const scope = useNormalizedSessionScope(channelId, agent?.user_id);
  return <NormalizedConversation scope={scope} outputMode={outputMode} surface={isDirectMessage ? 'workbench' : 'conversation'} defaultView={isDirectMessage ? 'messages' : 'session'} agentName={agent?.display_name}
    canWrite={canWrite} recipientAgent={agent ? { id: agent.user_id, name: agent.display_name } : undefined} draftKey={channelDraftKey(channelId)} messages={messages} composer={composer} />;
}
